<template>
  <b-modal
    id="view_group"
    title="Grupo"
    hide-footer
    @show="resetModal()"
    @shown="
      get();
      $refs.autofocus.focus();
    "
    @hidden="resetModal()"
  >
    <b-overlay :show="loading" opacity="0.99">
      <form @submit="update">
        <WarningRequiredFields v-if="permissions.permission_admin.edit" />
        <ErrorsMessages :errors="errors" />
        <div class="form-group">
          <LabelRequiredField label="Nome" />
          <input
            :disabled="!permissions.permission_admin.edit"
            type="text"
            ref="autofocus"
            class="form-control"
            v-model="name"
          />
        </div>
        <div class="form-group">
          <h6>
            <span class="text-muted">Criação:</span>
            {{ formatDate(group.created_at) }}
          </h6>
          <h6>
            <span class="text-muted">Última alteração:</span>
            {{ formatDate(group.updated_at) }}
          </h6>
        </div>
        <div class="form-group text-right">
          <v-btn class="v-primary" @click="$bvModal.hide('view_group')">
            <span class="fa fa-arrow-left"></span> Voltar
          </v-btn>
          <v-btn
            v-if="permissions.permission_admin.edit"
            type="submit"
            class="v-success"
          >
            <span class="fa fa-check"></span> Salvar
          </v-btn>
        </div>
      </form>
    </b-overlay>
  </b-modal>
</template>

<script>
import WarningRequiredFields from "../components/WarningRequiredFields";
import ErrorsMessages from "../components/ErrorsMessages";
import LabelRequiredField from "../components/LabelRequiredField";

import api from "../../services/api";
import { adminData } from "../../lib/functions";
import toast from "../../components/ToastNotification";

import { dialogConfirm } from "../../lib/functions";
import { formatDate } from "../../functions/format";

export default {
  name: "ViewGroup",
  components: {
    WarningRequiredFields,
    ErrorsMessages,
    LabelRequiredField,
  },
  props: {
    group_id: [String, Number],
  },
  data() {
    return {
      permissions: {},
      errors: [],

      loading: false,

      name: "",
      group: {},
    };
  },
  created() {
    this.permissions = adminData().permissions;
  },
  methods: {
    formatDate,
    dialogConfirm,
    async resetModal() {
      this.name = "";
      this.group = {};
    },
    async get() {
      try {
        this.loading = true;

        let params = { id: this.group_id };
        let response = await api.get("/admin/permission/group", {
          params,
        });
        let { error, errors, group } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.group = group;
          this.name = group.name;
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async update(ev) {
      try {
        ev.preventDefault();
        this.loading = true;

        let params = { id: this.group_id, name: this.name };
        let response = await api.patch("/admin/permission/group", params);
        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide("view_group");
          this.$emit("updated");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
</style>